[
  { "slug": "hotel-lake", "category": "Lake life" },
  { "slug": "weekend-in-garden-bay", "category": "Weekend itineraries" },
  { "slug": "pender-hill", "category": "Walks & hikes" },
  { "slug": "provisions", "category": "Plan your stay" }
]
